const s = {
  name: "Phone",
  dimensions: { width: 24, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 40" style="enable-background:new 0 0 24 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M12,6.3c0.7,0,1.2-0.6,1.2-1.2S12.7,3.8,12,3.8S10.8,4.3,10.8,5S11.3,6.3,12,6.3z"/>
		<path class="st0" d="M8,34h8v2H8V34z"/>
		<path class="st0" d="M0,5c0-2.8,2.2-5,5-5h14c2.8,0,5,2.2,5,5v30c0,2.8-2.2,5-5,5H5c-2.8,0-5-2.2-5-5V5z M5,2C3.3,2,2,3.3,2,5v30
			c0,1.7,1.3,3,3,3h14c1.7,0,3-1.3,3-3V5c0-1.7-1.3-3-3-3H5z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as Phone
};
